export default "__VITE_ASSET__BjC5S510__"